import { UserModule } from "@/store/modules/user";
import { getUuid } from '@/config/local'

export const getHeads = () => {
    return {
        "We-Device": "ADMIN-PC",
        "We-Token": UserModule.token,
        "We-Vcode": 100,
        "We-Uid":getUuid() || ''
    }
}
